import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import React, { useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { EButtonText, IHomePageModifiedData, IViewInterface } from '../utils/constants';
import { saveButton } from '../utils/style';
import useList from './useList';

const DataInputView: React.FC = (data: IViewInterface) => {
	const [css] = useStyletron();
	const { incCount } = useList();
	const { viewKey, viewType, homePageView, updatedHomePageView, setUpdatedHomePageView }: IViewInterface = data;
	const [inputValues, setInputValues] = useState<string[]>(() =>
		homePageView[viewType][viewKey].map((array: any) => array.join(','))
	);
	const [isActive, setIsActive] = useState(false);
	const [buttonText, setButtonText] = useState(EButtonText.SAVE);

	useEffect(() => {
		if (homePageView[viewType][viewKey]) {
			setInputValues(homePageView[viewType][viewKey].map((array: any) => array.join(',')));
		}
	}, [homePageView[viewType][viewKey]]);

	const handleOnSave = () => {
		setIsActive(true);
		setButtonText(EButtonText.SAVED);
		if (!updatedHomePageView[viewType as keyof IHomePageModifiedData]) {
			updatedHomePageView[viewType as keyof IHomePageModifiedData] = {};
		}
		updatedHomePageView[viewType as keyof IHomePageModifiedData][viewKey] = inputValues;
		setUpdatedHomePageView(updatedHomePageView);
	};

	const handleInputChange = (index: number, value: string) => {
		const newInputValues = [...inputValues];
		newInputValues[index] = value;
		setInputValues(newInputValues);
	};

	const onDragEnd = (result: any) => {
		if (!result.destination) return;

		const reorderedValues = Array.from(inputValues);
		const [removed] = reorderedValues.splice(result.source.index, 1);
		reorderedValues.splice(result.destination.index, 0, removed);
		setIsActive(false);
		setButtonText(EButtonText.SAVE);
		setInputValues(reorderedValues);
	};

	return (
		<div>
			<DragDropContext onDragEnd={onDragEnd}>
				<Droppable droppableId='inputs'>
					{(provided: any) => (
						<div {...provided.droppableProps} ref={provided.innerRef}>
							{inputValues.map((value: string, index: number) => (
								<Draggable key={`drag-${incCount()}`} draggableId={`draggable-${index}`} index={index}>
									{(provided1: any) => (
										<div ref={provided1.innerRef} {...provided1.draggableProps} {...provided1.dragHandleProps}>
											<input
												type='text'
												className='form__input'
												value={value}
												readOnly
												onChange={(e) => handleInputChange(index, e.target.value)}
											/>
										</div>
									)}
								</Draggable>
							))}
							{provided.placeholder}
						</div>
					)}
				</Droppable>
			</DragDropContext>
			<Button
				className={css(saveButton)}
				onClick={handleOnSave}
				style={{
					backgroundColor: isActive ? 'green' : 'black'
				}}>
				{buttonText}
			</Button>
		</div>
	);
};

export default DataInputView;
